"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalStyles = void 0;
require("focus-visible");
require("./global.css");
var _borderRadius = require("./borderRadius");
var _borderWidth = require("./borderWidth");
// focus visible polyfill

const globalStyles = "cds-globalStyles-gfheqpx";
exports.globalStyles = globalStyles;